import {HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {catchError, retry} from "rxjs/operators";
import {inject, Injectable} from "@angular/core";
import notify from "devextreme/ui/notify";
import {AuthService} from "@auth0/auth0-angular";

/**
 * Set on a request's HttpContext to suppress this interceptor's generic error toast,
 * e.g. when the calling component already shows its own friendly, operation-specific
 * notification on failure. Defaults to false so every other request keeps today's
 * raw global toast behavior unchanged.
 */
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    private auth = inject(AuthService);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
            .pipe(
                retry(0),
                catchError((error: HttpErrorResponse) => {
                    if (error.status === 401) {
                        this.auth.loginWithRedirect();
                        return throwError(() => error);
                    }
                    let errorMessage = "";
                    if (error.error instanceof ErrorEvent) {
                        // client-side error
                        errorMessage = `${error.error.message}`;
                    } else {
                        // server-side error
                        console.log(error);

                        const message = typeof error.error === 'object'
                            ? error.error?.error || error.error?.message
                            : error.error || error.message;

                        if(message) {
                            errorMessage = `${message}`;
                        } else if(error.message) {
                            errorMessage = `${error.message}`;
                        }

                    }
                    if (error.status !== 200) {
                        switch (error.status) {
                            case 409:
                                errorMessage = `Conflict: ${errorMessage}`;
                                break;
                            default:
                                 errorMessage = `Error: ${error.message}`;
                        }
                    }
                    if(errorMessage && !request.context.get(SKIP_ERROR_TOAST)){
                        notify(errorMessage, 'error', 5000);
                    }
                    return throwError(errorMessage);
                })
            );
    }
}
